import { t as e } from "../../chunks/cn.CW-jpn-X.js";
import { XIcon as t } from "lucide-react";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { Transforms as i } from "slate";
import { ReactEditor as a } from "slate-react";
// lib/TVListing/components/FieldRow.tsx
var o = ({ editor: o, element: s, label: c, align: l = "center", mandatory: u = !1, children: d, onRemove: f }) => /* @__PURE__ */ r("div", {
	className: e("group border-b flex gap-3 text-sm py-2", l === "start" ? "items-start" : "items-center"),
	children: [
		/* @__PURE__ */ n("label", {
			contentEditable: !1,
			className: "w-14 text-sm opacity-70",
			children: c
		}),
		/* @__PURE__ */ n("div", {
			className: "flex-1 min-w-0",
			children: d
		}),
		!u && /* @__PURE__ */ n("button", {
			contentEditable: !1,
			type: "button",
			onMouseDown: (e) => {
				if (e.preventDefault(), e.stopPropagation(), f) f();
				else try {
					let e = a.findPath(o, s);
					i.removeNodes(o, { at: e });
				} catch {}
			},
			title: `Ta bort ${c.toLowerCase()}`,
			className: "opacity-0 group-hover:opacity-60 hover:!opacity-100 hover:bg-slate-200 dark:hover:bg-gray-700 p-1 rounded transition-opacity",
			children: /* @__PURE__ */ n(t, {
				size: 14,
				className: "text-black dark:text-white"
			})
		})
	]
});
export { o as FieldRow };
